// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1vZsQ","load4":"Spinner_load4__2i8Im","small":"Spinner_small__26EGg"};